import { useContext } from 'react'
import * as Yup from 'yup'

import { RiskProductsContext } from '../../context'
import { R } from '@utils/currency'

export const setupValidations = () => {
  const { state } = useContext(RiskProductsContext)
  const { riskProducts, riskProduct, formFields } = state
  const schema = {}
  const riskProductNames = getRiskProductNames(riskProducts, riskProduct)
  const riskProductValidations = buildRiskProductValidations(riskProductNames)
  
  // Extract field names from formFields array
  const validationFields = formFields.map(field => field.name)
  
  validationFields.forEach((fieldName) => {
    schema[fieldName] = riskProductValidations[fieldName]
  })
  return Yup.object().shape(schema)
}

const getRiskProductNames = (riskProducts, currentRiskProduct = {}) => {
  const riskProductNames = riskProducts.map((riskProduct) => riskProduct.name)
  const indexToRemove = riskProductNames.indexOf(currentRiskProduct.name)
  if (indexToRemove > -1) { riskProductNames.splice(indexToRemove, 1) }

  return riskProductNames
}

const buildRiskProductValidations = (riskProductNames) => {
  const riskProductValidations = {
    name: Yup.string()
      .required('A name for the risk product is required')
      .typeError('A valid name for the risk product is required')
      .notOneOf(riskProductNames, 'A unique name for the risk product is required'),
    value: Yup.number()
      .nullable()
      .test('riskProductHasValue', 'You have to enter the outstanding balance for your risk product', riskProductValueTest)
      .typeError('A numeric value for the outstanding balance is required'),
    monthly_contribution: Yup.number()
      .nullable()
      .test('riskProductHasValue', 'You have to enter a monthly replayment', riskProductValueTest)
      .typeError('A numeric value for the monthly contribution is required'),
    contract_number: Yup.string()
      .nullable()
      .typeError('A valid contract number for the risk product is required'),
    service_provider_id: Yup.mixed()
      .nullable()
      .typeError('A service provider is required'),
  }
  return riskProductValidations
}

function riskProductValueTest() {
  const { monthly_contribution, value } = this.parent
  const testValue = R(monthly_contribution).value + R(value).value

  return testValue > 0
}
